"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = exports.ThemeContext = void 0;
var React = _interopRequireWildcard(require("react"));
var _defaultTheme = _interopRequireDefault(require("../../defaultTheme"));
const ThemeContext = exports.ThemeContext = /*#__PURE__*/React.createContext(_defaultTheme.default);
const ThemeProvider = ({
  children,
  theme
}) => {
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, children);
};
var _default = exports.default = ThemeProvider;